import {$} from './dom.js';
import {read,write,STORAGE_KEYS} from './storage.js';

class SoundManagerController{
  #enabled=read(STORAGE_KEYS.SOUND)!=='off';
  #context=null;#master=null;#epoch=0;#initialized=false;#sources=new Set();

  get enabled(){return this.#enabled}

  async unlock(){
    if(!this.#enabled)return false;
    try{
      if(!this.#context){
        const AudioContextClass=window.AudioContext||window.webkitAudioContext;
        if(!AudioContextClass)return false;
        this.#context=new AudioContextClass();this.#master=this.#context.createGain();this.#master.gain.value=.7;this.#master.connect(this.#context.destination);
      }
      if(this.#context.state!=='running')await this.#context.resume();
      return this.#context.state==='running';
    }catch{return false}
  }

  setEnabled(value){
    this.#enabled=Boolean(value);this.#epoch++;write(STORAGE_KEYS.SOUND,this.#enabled?'on':'off');
    if(this.#master){const now=this.#context.currentTime;this.#master.gain.cancelScheduledValues(now);this.#master.gain.setValueAtTime(this.#enabled ? .7 : 0,now)}
    if(!this.#enabled){for(const source of this.#sources){try{source.stop()}catch{}}this.#sources.clear()}
    this.#render();if(this.#enabled)void this.unlock();
  }

  init(){
    if(this.#initialized)return;this.#initialized=true;this.#render();
    document.addEventListener('pointerdown',()=>void this.unlock(),{capture:true,passive:true});
    document.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' ')void this.unlock()},{capture:true});
    $('#soundToggle').addEventListener('click',()=>this.setEnabled(!this.#enabled));
  }

  #render(){
    const toggle=$('#soundToggle');toggle.setAttribute('aria-pressed',String(this.#enabled));
    toggle.setAttribute('aria-label',`Sound ${this.#enabled?'on':'off'}. ${this.#enabled?'Mute':'Enable'} app sounds.`);
    $('.sound-label').textContent=this.#enabled?'Sound on':'Sound off';
  }

  #track(source,gain,filter){
    this.#sources.add(source);source.onended=()=>{this.#sources.delete(source);source.disconnect();gain.disconnect();filter?.disconnect()};
  }

  #tone(time,frequency,duration,volume){
    const oscillator=this.#context.createOscillator(),gain=this.#context.createGain();
    oscillator.type='sine';oscillator.frequency.setValueAtTime(frequency,time);oscillator.frequency.exponentialRampToValueAtTime(frequency*.985,time+duration);
    gain.gain.setValueAtTime(0,time);gain.gain.linearRampToValueAtTime(volume,time+.012);gain.gain.exponentialRampToValueAtTime(.0001,time+duration);
    oscillator.connect(gain).connect(this.#master);this.#track(oscillator,gain);oscillator.start(time);oscillator.stop(time+duration+.015);
  }

  #paper(time,duration,volume,frequency){
    const buffer=this.#context.createBuffer(1,Math.ceil(this.#context.sampleRate*duration),this.#context.sampleRate),data=buffer.getChannelData(0);
    for(let index=0;index<data.length;index++)data[index]=Math.random()*2-1;
    const source=this.#context.createBufferSource(),gain=this.#context.createGain(),filter=this.#context.createBiquadFilter();
    source.buffer=buffer;filter.type='lowpass';filter.frequency.value=frequency;filter.Q.value=.5;
    gain.gain.setValueAtTime(0,time);gain.gain.linearRampToValueAtTime(volume,time+.004);gain.gain.exponentialRampToValueAtTime(.0001,time+duration);
    source.connect(filter).connect(gain).connect(this.#master);this.#track(source,gain,filter);source.start(time);source.stop(time+duration+.01);
  }

  #play(build){
    if(!this.#enabled)return;const ticket=this.#epoch;
    const run=()=>{if(this.#enabled&&ticket===this.#epoch&&this.#context?.state==='running')build(this.#context.currentTime+.005)};
    if(this.#context?.state==='running')run();else void this.unlock().then(ok=>{if(ok)run()});
  }

  playStopPress(){this.#play(time=>{this.#paper(time,.065,.18,600);this.#tone(time,145,.075,.09);this.#tone(time+.055,392,.16,.065);this.#tone(time+.085,588,.16,.035)})}
  playDiceTick(){this.#play(time=>{this.#paper(time,.042,.14,1150);this.#tone(time,190,.045,.065)})}
  playDiceLand(){this.#play(time=>{this.#paper(time,.075,.17,750);this.#tone(time,245,.12,.08);this.#tone(time+.02,490,.10,.022)})}
  playJarLand(){this.#play(time=>{this.#tone(time,784,.15,.065);this.#tone(time+.025,1176,.11,.022);this.#paper(time,.026,.03,1800)})}
  playSave(){this.#play(time=>{this.#paper(time,.04,.1,1450);this.#tone(time+.025,440,.13,.06);this.#tone(time+.07,660,.16,.035)})}
  playPark(){this.#play(time=>{this.#paper(time,.09,.085,980);this.#tone(time+.085,392,.12,.045);this.#tone(time+.135,588,.13,.026)})}
  playTimerStart(){this.#play(time=>{this.#paper(time,.025,.055,900);this.#tone(time,330,.07,.035)})}
  playTimerEnd(){this.#play(time=>{this.#tone(time,440,.2,.065);this.#tone(time+.085,660,.22,.035)})}
  playBreakEnd(){this.#play(time=>{this.#tone(time,523,.16,.045);this.#tone(time+.07,784,.18,.025)})}
  playShred(){this.#play(time=>{this.#paper(time,.22,.07,1100);this.#paper(time+.15,.2,.05,700);this.#tone(time+.34,392,.12,.025)})}
}

export const SoundManager=new SoundManagerController();
